.search-widget-dropdown {
  overflow-y : auto;
  white-space: normal;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 2px solid var(--color-palette-neutral-300, #CBCECE);
  max-height: calc(100vh - 64px);

  p, b {
    color: $c11n-color-ink-800;
  }

  hr {
    margin: 0;
    background-color: var(--color-palette-neutral-300, #CBCECE);
    height: 1px;
    border: 0;
  }

  .hidden {
    display: none;
  }

  .search-widget-text {
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
  }

  .search-widget-dropdown-list {
    padding: 0.5rem 0;

    @include  media-breakpoint-down(md) {
      .search-widget-dropdown-listname {
        padding: 7px 27px !important;
        margin-bottom: 0 !important;
        padding-bottom: 4px !important;
      }

      .search-widget-dropdown-list-item {
        padding: 7px 27px !important;
      }
    }

    .search-widget-dropdown-listname {
      padding: 7px 1rem 0;
      margin-bottom: 5px;
    }

    p {
      text-overflow: ellipsis;
      word-wrap: break-word;
      overflow: hidden;
      max-height: 2.5rem;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }

    .products-list .search-widget-dropdown-list-item p {
      width: calc(100% - 93px);

      @include media-breakpoint-down(md) {
        width: calc(100% - 81px);
      }
    }

    .search-widget-dropdown-list-item {
      cursor: pointer;
      padding: 6px 1rem;
      border: none;
      background-color: transparent;
      display: flex;
      text-align: left;
      align-items: flex-start;
      width: 100%;

      &:hover {
        background: var(--color-palette-neutral-200, #E8E9E9);
      }

      img {
        margin-right: 8px;
        margin-top: 3px;
      }

      .product-name {
        width: 93px;

        @include media-breakpoint-down(md) {
          width: 81px;
        }
      }

      &.no-background {
        padding-top: 0 !important;
        padding-bottom: 0 !important;

        &:hover {
          background-color: transparent;
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    width: 100%;
  }
}
